import TemplateFlex from 'typescript-styled-flex'

export default TemplateFlex
